import React from 'react';

const UserOnlineStatus = () => {
    return (
        <div>
            
        </div>
    );
}

export default UserOnlineStatus;
